export const FIELD_LABELS = {
    make: 'make',
    model: 'model',
    serial: 'Serial number',
    series: 'series',
    manufacturer: 'manufacturer',
    quantity: 'quantity',
    acPowerRatingW: 'AC power rating (W)',
    acCurrentNominalA: 'AC nominal current (A)',
    ipRating: 'IP rating',
    dcVoltageMpptLowerV: 'MPPT minimum voltage (V)',
    dcVoltageMpptUpperV: 'MPPT maximum voltage (V)',
    dcVoltageMaximumV: 'Maximum DC voltage (V)',
    dcCurrentMaximumA: 'Maximum DC current (A)',
    dcCurrentShortCircuitA: 'DC short-circuit current (A)',
    galvanicallyIsolated: 'galvanically isolated',
    powerRatingW: 'Power per panel (W)',
    voltageOpenCircuitV: 'Open-circuit voltage (V)',
    currentShortCircuitA: 'Short-circuit current (A)',
    serials: 'Serial numbers',
    systemType: 'system type',
    capacityKwh: 'Capacity (kWh)',
    installLocation: 'install location',
    inverterSerial: 'inverter serial',
    dvcClassification: 'DVC classification',
    ratingA: 'Rating (A)',
    insideSwitchboard: 'inside switchboard',
    nextToInverter: 'next to inverter',
    voltageV: 'Voltage (V)',
    currentA: 'Current (A)',
    location: 'location',
    locationOther: 'other location',
    polarised: 'polarised',
    panelsInLongestString: 'panels in longest string',
    numberOfStrings: 'number of strings',
    arrayModuleIndex: 'array module',
    totalArrayVoltageOpenCircuitV: 'Total array open-circuit voltage (V)',
    totalArrayCurrentShortCircuitA: 'Total array short-circuit current (A)',
    verifiedAgainstCer: 'verified against CER',
    circuitBreakerSizeMainSwitchGrid: 'Main switch (grid) circuit breaker',
    circuitBreakerSizeMainSwitchInverter: 'Main switch inverter/alternative circuit breaker',
    alternativeSupplyFromBessInverter: 'Alternative supply from the BESS/inverter',
    switchboardLabellingRequirementsMet: 'Switchboard labelling requirements met',
};
export function hardwarePathLabel(path) {
    const row = /^(inverters|modules|batteries|acIsolators|dcIsolators)\[(\d+)\]\.(.+)$/.exec(path);
    const rows = {
        inverters: 'Inverter',
        modules: 'Module',
        batteries: 'Battery',
        acIsolators: 'AC isolator',
        dcIsolators: 'DC isolator',
    };
    const key = row?.[3] ?? path;
    const text = FIELD_LABELS[key] ?? key.replace(/([a-z])([A-Z])/g, '$1 $2');
    const label = text.charAt(0).toUpperCase() + text.slice(1);
    return row ? `${rows[row[1]]} ${Number(row[2]) + 1} · ${label}` : label;
}
export const NUMERIC_HARDWARE_FIELDS = new Set([
    'quantity',
    'acPowerRatingW',
    'acCurrentNominalA',
    'dcVoltageMpptLowerV',
    'dcVoltageMpptUpperV',
    'dcVoltageMaximumV',
    'dcCurrentMaximumA',
    'dcCurrentShortCircuitA',
    'powerRatingW',
    'voltageOpenCircuitV',
    'currentShortCircuitA',
    'capacityKwh',
    'ratingA',
    'voltageV',
    'currentA',
    'panelsInLongestString',
    'numberOfStrings',
    'arrayModuleIndex',
    'totalArrayVoltageOpenCircuitV',
    'totalArrayCurrentShortCircuitA',
]);
//# sourceMappingURL=hardware-labels.js.map